import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux"; // 引入 useSelector
import { ConfigProvider } from "antd";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { customerThemeToken } from "@/customerTheme";
import VersionFooter from "@COM/VersionFooter";
import Language from "@COM/Language";
import Loading from "@COM/Loading";
import { AZURE_USER_API } from "@CON";
import { messageGenerator } from "@UTIL";
import { setUser, setUserType, setToken } from "@STORE";

function AzureLogin() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.user);

  useEffect(() => {
    const fetchData = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const userIdToken = urlParams.get("token");

      if (userIdToken) {
        try {
          const res = await axios.post(`${AZURE_USER_API}?userOId=${userIdToken}`);
          const { result = "error", data, errMsg } = res;

          if (result === "success") {
            dispatch(setUser(data.User));
            dispatch(setUserType(data.UserType));
            dispatch(setToken(data.token));

            const redirectUrl = sessionStorage.getItem("redirectUrl");
            const sameUser = userInfo?.Id === data.User.Id;

            if (redirectUrl && sameUser) {
              navigate(redirectUrl, { replace: true });
            } else {
              console.log("Login");
              sessionStorage.setItem("netZero", "true");
              navigate("/", { replace: true });
            }
          } else {
            messageGenerator({ 
              result,
              content: errMsg ?? t("MessageText.Login failed"),
            });
            navigate("/login", { replace: true }); // 登入失敗重新導向
          }
        } catch (error) {
          console.error("Azure 登入請求失敗:", error);
          messageGenerator({ 
            result: "error",
            content: t("MessageText.Login failed") + " - " + error.message, // 顯示錯誤訊息
          });
          navigate("/login", { replace: true }); 
        }
      } else {
        console.error("URL 中缺少 userId token");
        navigate("/login", { replace: true }); 
      }
    };

    fetchData();
  }, [dispatch, navigate, userInfo]); 

  return (
    <ConfigProvider
      csp={{ nonce: "2726c7f26c" }}
      theme={{
        token: customerThemeToken,
      }}
    >
      <Language>
        <section
          className="w-100 min-vh-100 d-flex flex-column justify-content-center align-items-center"
          style={{ backgroundColor: "#F0F9FF" }}
        >
          <Loading />
          <VersionFooter />
        </section>
      </Language>
    </ConfigProvider>
  );
}

export default AzureLogin;